import React from 'react'
import { ZdsTypography } from '@zera/components'
import { Message } from '../Message'
import { Divider, Stack } from '~/styles'

const { REACT_APP_LLM_RESPONSE_NPS_FORM_URL: formURL = '#' } = process.env

type LLMResponseMessageProps = {
  llmResponse?: string
}

export const LLMResponseMessage = ({ llmResponse }: LLMResponseMessageProps): JSX.Element => {
  const noReply = !llmResponse

  if (noReply) return <></>

  return (
    <Message.RootLeft>
      <Message.UserAvatar iconName="MiMaleDoctor" />
      <Stack spacing="0.5rem" alignItems="flex-start">
        <Message.UserName username="IA Interativa" />
        <Message.FromLeft>
          <Message.MarkdownFormattedText text={llmResponse} />
          <Message.Footer>
            <Stack width="100%" alignItems="flex-start">
              <Divider />
              <ZdsTypography variant="body300">
                <p>
                  <strong>A sua opinião é muito importante!</strong>
                  <br />
                  Avalie a minha resposta utilizando o formulário:{' '}
                  <a href={formURL} target="_blank" rel="noreferrer">
                    {formURL}
                  </a>
                </p>
              </ZdsTypography>
            </Stack>
          </Message.Footer>
        </Message.FromLeft>
      </Stack>
    </Message.RootLeft>
  )
}
